<!--
  @Description: 
  @Author: wang.y 
  @Date: 2024-07-23 
-->
<template>
  <div :class="['fixed-btns']">
    <div class="item" v-for="item,index in btnList" :key="index" @click="clickBanner(item, 'right-btn')">
      <div class="iconfont-wrap">
        <i class="iconfont" v-if="index == 0">&#xe6e2;</i>
        <i class="iconfont" v-if="index == 1">&#xe6e4;</i>
        <i class="iconfont" v-if="index == 2" style="font-size: 17px">&#xe6e5;</i>
        <i class="iconfont" v-if="index == 3">&#xe6e3;</i>
      </div>
      <div class="font">{{item.description}}</div>
    </div>
  </div>
</template>
<script>
export default {
  inject: ['clickBanner'],
  props: {
    btnList: {
      default: () => [],
    },
  },
  data() {
    return {
      isScroll: false,
    }
  },
  methods: {},
}
</script>
<style lang='stylus' scoped>
.fixed-btns
  position fixed
  width 154px
  right 0
  bottom 190px
  cursor pointer
  z-index 998
  transition all 0.3s
  &.on
    right -75px
  & > div
    position relative
    width 100%
    height 50px
    display flex
    align-items center
    background-color #4E77DF
    padding 5px 0 5px 5px
    border-radius 25px 0 0 25px
    transition all 0.3s
    &:hover
      background-color #FA5A00
    & + div
      margin-top 10px
    .iconfont-wrap
      display flex
      align-items center
      justify-content center
      max-width 40px
      min-width 40px
      height 40px
      background #FFFFFF
      border-radius 50%
      overflow hidden
      line-height 1
      i.iconfont
        color #FA5A00
        font-size 22px
    .font
      color #fff
      font-size 16px
      line-height 22px
      margin-left 6px
</style>